/** Factory the app uses. OWNER: HUD-UI-AUDIO agent (keep the name). */
import type { MenuSystem } from '../types';
import { Bo2Menus } from './menus';

export function createMenus(): MenuSystem {
  return new Bo2Menus();
}
